import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_KEYSTONE_RANKINGS_ERROR,
  SET_KEYSTONE_RUN_RANKINGS,
  SHOW_KEYSTONE_LOADING_SPINNER
} from '../actions/keystoneActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';

const roleSorts: any = {
  tank: 1,
  healer: 2,
  dps: 3
};

function ordinalForRole(role: string): number {
  if (!role) {
    return 999;
  }
  const roleCheck = role.toLowerCase();
  return roleSorts[roleCheck] || 999;
}

function sortRoster(a: any, b: any) {
  const aRoleOrder = ordinalForRole(a.role);
  const bRoleOrder = ordinalForRole(b.role);
  if (aRoleOrder === bRoleOrder) {
    if (b.character.name === a.character.name) {
      return 0;
    } else if (a.character.name < b.character.name) {
      return -1;
    } else {
      return 1;
    }
  } else {
    return aRoleOrder - bRoleOrder;
  }
}

const DEFAULT_STATE = {
  instances: {}
};

export default function keystoneRankings(
  state: Partial<TCharacterDetailsClientState> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case SET_KEYSTONE_RUN_RANKINGS: {
      action.payload.data?.rankedGroups?.forEach((group: any) => {
        group.run.roster.sort(sortRoster);
      });

      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            ...action.payload.data
          }
        }
      };
    }
    case SET_KEYSTONE_RANKINGS_ERROR: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            isError: true,
            error: action.payload.error
          }
        }
      };
    }
    case SHOW_KEYSTONE_LOADING_SPINNER: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            ...state.instances[action.payload.instanceId],
            isLoading: action.payload.show
          }
        }
      };
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default: {
      return state;
    }
  }
}
